(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('district-village-block-mapping', {
            parent: 'entity',
            url: '/district-village-block-mapping',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.districtVillageBlockMapping.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mappings.html',
                    controller: 'DistrictVillageBlockMappingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtVillageBlockMapping');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('district-village-block-mapping-detail', {
            parent: 'district-village-block-mapping',
            url: '/district-village-block-mapping/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.districtVillageBlockMapping.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-detail.html',
                    controller: 'DistrictVillageBlockMappingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtVillageBlockMapping');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DistrictVillageBlockMapping', function($stateParams, DistrictVillageBlockMapping) {
                    return DistrictVillageBlockMapping.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'district-village-block-mapping',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('district-village-block-mapping-detail.edit', {
            parent: 'district-village-block-mapping-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-dialog.html',
                    controller: 'DistrictVillageBlockMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictVillageBlockMapping', function(DistrictVillageBlockMapping) {
                            return DistrictVillageBlockMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-village-block-mapping.new', {
            parent: 'district-village-block-mapping',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-dialog.html',
                    controller: 'DistrictVillageBlockMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                districtName: null,
                                category: null,
                                village: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('district-village-block-mapping', null, { reload: 'district-village-block-mapping' });
                }, function() {
                    $state.go('district-village-block-mapping');
                });
            }]
        })
        .state('district-village-block-mapping.edit', {
            parent: 'district-village-block-mapping',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-dialog.html',
                    controller: 'DistrictVillageBlockMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictVillageBlockMapping', function(DistrictVillageBlockMapping) {
                            return DistrictVillageBlockMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-village-block-mapping', null, { reload: 'district-village-block-mapping' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-village-block-mapping.delete', {
            parent: 'district-village-block-mapping',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-delete-dialog.html',
                    controller: 'DistrictVillageBlockMappingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DistrictVillageBlockMapping', function(DistrictVillageBlockMapping) {
                            return DistrictVillageBlockMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-village-block-mapping', null, { reload: 'district-village-block-mapping' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
